import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { LabelForm, LabelCabecera} from '../componentes_generales/componentes_formulario/labels/';
import styled from 'styled-components';
import global_axios  from '../../funciones_globales/interaccionapi';
import { cargarCatalogosGenerico, cargarCatalogos_Otros, cargarCatalogosGenericoAsync} from '../../funciones_globales/catalogos';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { formatearFecha } from '../../funciones_globales/format';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { validarPermisoAcceso } from '../../funciones_globales/utils';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';

const ButtonUnion = styled.button`
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
    z-index: 0;
`;

class FormCaja02 extends React.Component{
    constructor(props){
        super(props);
        this.state = {            
            
            permiso:'C', //cargarlo con funcion para validar permisos
            operacion: 'G', //G GUARDAR - M Modificar
            movCargado: false,
            planVigente: null,
            movcaja: "",

            caja: [],
            caja_sel: '02',

            cajaOpe: [],
            cajaOpe_sel: '',

            fecha: moment(getItemDatosSesion('fechasistema'), 'DD/MM/YYYY'),

            tipoIngreso:[],
            tipoIngreso_sel: 'EF',

            valor: '',
            beneficiario: '',
            concepto: '',

            ult_transaccion: null, //Ultima transaccion operada

            opcMutables: [],//combo mutable
            opcMutables_sel: ''
        };

        this.getMovCaja = this.getMovCaja.bind(this);
        this.changeMovCaja = this.changeMovCaja.bind(this);
        this.changeValueGeneral = this.changeValueGeneral.bind(this);
        this.changeValueCombo = this.changeValueCombo.bind(this);
        this.ingresoValores = this.ingresoValores.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.guardarMovimiento = this.guardarMovimiento.bind(this);
        this.getOptions_Rubro = this.getOptions_Rubro.bind(this);
    }

    getOptions_Rubro(input, callback){
        if (input.toString().length >= 3 ){            
            let cadena_busq = '?opcion=GASTO&cadena_busq='+input+'&plan='+this.state.planVigente
            cargarCatalogosGenericoAsync('/rubroscontables', cadena_busq, callback)  
        }
    }
    
    getMovCaja(){
        if(this.state.movcaja === ''){
            alert("Digite un movimiento");
        }else if(parseInt(this.state.movcaja,10) < 0 || this.state.movcaja==='' ){
            alert("Movimiento no valido");
            this.limpiar();
        }else{
            global_axios({
                method: 'GET',
                url: 'caja/movcaja/'+this.state.movcaja.toString()
            })
            .then((response)=> {
                //Asignaciones a states
                console.log(response.data);
                var result = response.data;
                var opcMutables_sel_result = result.opcMutables_sel;

                this.setState({caja_sel: result.caja_sel});
                this.setState({valor: result.valor});

                //Conversion y asignacion fecha
                let fecha = formatearFecha(result.fecha);
                this.setState({fecha: moment(fecha, 'DD/MM/YYYY')});

                this.setState({concepto: result.concepto});
                this.setState({beneficiario: result.beneficiario});

                //carga de item seleccionado de combo operacion                    
                this.setState({cajaOpe_sel: result.cajaOpe_sel});

                //carga de combo dinamico
                let parametros = 'CAJA-' + result.cajaOpe_sel;

                Promise.all([
                    cargarCatalogos_Otros(parametros)
                ])
                .then(([result]) => {
                   
                    console.log("resultado: ", result);
                    this.setState({opcMutables: result})
                    this.setState({opcMutables_sel: opcMutables_sel_result,
                        operacion: 'M'});
                })
            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });
        }
    }

    componentDidMount(){
        Promise.all([
            cargarCatalogos_Otros('GEN-PLANVIG'),cargarCatalogos_Otros('CAJA-OPE'), cargarCatalogosGenerico('/caja'), cargarCatalogos_Otros('CAJA-PAGO'),
            this.props.generar_LogAuditoriaIngresoForm('0502')
        ])
        .then(([r_planVigente, result_cajaOperacion, result_caja, result_pago, result_gasto, result_egreso, result_ingreso]) => {
        console.log("OPERACIONES: ", r_planVigente)
        this.setState(
            { cajaOpe: result_cajaOperacion, caja: result_caja, tipoIngreso: result_pago, planVigente: r_planVigente[0].value,
            permiso: this.props.permiso ,fecha: moment(this.props.fechaProceso,'DD/MM/YYYY')})
        })
        .catch(err => {
            console.log(err);
        });        
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0502');
    }

    changeValueGeneral(event){    
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        
        this.setState({            
        [name]: value
        });
    }

    changeMovCaja(event){
        this.clear();       
        const target = event.target;    
        const value = target.value;
        this.setState({movcaja: value});

        //Evalua si es una carga o no
        if(value === ""){
            this.setState({movCargado: false});
        }else{
            this.setState({movCargado: true});
        }
    }

    changeValueCombo(value){

        if(value!==null){
            this.setState({cajaOpe_sel: value.value});

            this.setState({opcMutables: []})
            if (value.value !== undefined && value.value !== ''){
                let parametros = 'CAJA-' + value.value;
                Promise.all([
                    cargarCatalogos_Otros(parametros)
                ])
                .then(([result]) => {
                    this.setState({opcMutables: result})
                })                
            }
        }
    }

    ingresoValores(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox' ? target.checked : target.value;
        if(isNaN(value)===false){
            this.setState({
                [name]: value
            });
        }
    }

    guardarMovimiento(){
        var data = {};
        var proceder = false;
        var errors = "";

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }

        if(this.state.cajaOpe_sel === 'INI'){
            if( this.state.cajaOpe_sel === ''&& parseFloat(this.state.valor) <= 0){
                errors=errors+"- Complete todos los campos para continuar\n";
            }else{
                proceder = true;
            }
        }

        if( this.state.cajaOpe_sel !== 'INI' &&  this.state.opcMutables_sel.value !== '' && this.state.concepto !== '' && this.state.beneficiario !== '' 
            && parseFloat(this.state.valor) > 0){
                proceder = true;
        }else{
            errors=errors+"- Complete todos los campos para continuar\n";
        }   

        if(proceder === true){
            let transaccion = window.confirm('¿Seguro de grabar el movimiento?');
            if(transaccion){

                //Asignacion
                data.operacion_sp = (this.state.movCargado === false?'I':'U');
                data.fecha_caja = this.state.fecha;
                data.caja = this.state.caja_sel;
                data.operacion = this.state.cajaOpe_sel;
                data.rubro = this.state.opcMutables_sel;
                data.concepto = this.state.concepto;
                data.beneficiario = this.state.beneficiario;
                data.valor = parseFloat(this.state.valor);
                data.tipoIngreso = this.state.tipoIngreso_sel; //EF = EFECTIVO, CH = CHEQUE, DP = DEPOSITO, TA = Tarjeta credito
                //Campo usuario
                data.usuario =  getItemDatosSesion('usuario').toString();
                //Campos moneda
                data.moneda = JSON.parse(getItemDatosSesion('moneda')).Moneda;
                data.dolar = JSON.parse(getItemDatosSesion('moneda')).Cotizacion;

                let config_request = {                    
                    method: 'POST',
                    url: 'caja/movcaja/',
                    data
                }

                global_axios(config_request)
                .then((response)=> {                    
                    alert(response.data.msg);
                    this.setState({ult_transaccion: response.data.transaction, operacion: 'G'})
                    this.clear();
                })
                .catch((error)=>{                
                    alert(error.response?error.response.data.msg:error.message);      
                });
            }       
        }else{
            alert(errors);
        }
        
    }

    limpiar(){
        this.clear();
        
    }

    clear(){
        this.setState({movcaja: ''});
        this.setState({caja_sel: '02'});
        this.setState({cajaOpe_sel: ''});
        this.setState({fecha: moment(getItemDatosSesion('fechasistema'), 'DD/MM/YYYY')});
        this.setState({tipoIngreso_sel: 'EF'});
        this.setState({beneficiario: ''});
        this.setState({concepto: ''});
        this.setState({valor: ''});
        this.setState({opcMutables_sel: '', operacion: 'G'});

        this.clearEstados();
    }

    clearEstados(){        
        this.setState({movCargado: false});
    }

    render(){
        return(
            <ContenedorForm porc_ancho={65}>
            <HeaderForm>
                <TituloForm>Movimiento caja</TituloForm>
                <LabelCabecera>Ult. trans.: {this.state.ult_transaccion}</LabelCabecera>
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit>
                        <Row>
                            <ContainerCol className='col-md-4'>
                                <LabelForm>Movimiento:</LabelForm>
                                <div className='input-group'>
                                    <InputText name='movcaja' value={this.state.movcaja} type="number" className='form-control input-sm' placeholder='Movimiento' onChange={this.changeMovCaja}/>
                                    <span className='input-group-addon addon-busq-especif'><ButtonUnion type="button" className='btn btn-default medida-button-busq-especif' onClick={this.getMovCaja}><i className="fa fa-check-circle-o"></i> Seleccionar</ButtonUnion></span>
                                </div>
                            </ContainerCol>
                            <ContainerCol className='col-md-2 col-md-offset-6'>
                                <LabelForm>Fecha:</LabelForm>
                                <PickerFecha fechaSeleccionada={this.state.fecha} func_onChange={(fechaEscogida)=>{this.setState({fecha: fechaEscogida})}}/>
                            </ContainerCol>
                        </Row>
                    </ContainerEdit>
                    <Row>
                        <ContainerCol className='col-md-3'>
                            <LabelForm>Caja:</LabelForm>
                            <ReactSelect options={ this.state.caja } value={this.state.caja_sel} func_onChange={(value)=>{this.setState({caja_sel: value})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-4'>
                            <LabelForm>Operación:</LabelForm>
                            <ReactSelect options={ this.state.cajaOpe } value={this.state.cajaOpe_sel} func_onChange={(value)=>{this.changeValueCombo(value)}} />
                        </ContainerCol>
                        <ContainerCol className='col-md-5'>
                            <LabelForm>{(this.state.cajaOpe_sel.value==='VAL'?'Gasto:':'Rubro:')}</LabelForm>
                            <ReactSelectAsync value={this.state.opcMutables_sel} func_loadOptions={this.getOptions_Rubro} func_onChange={(value)=>{this.setState({opcMutables_sel: value!==null?value:null})}}/>
                            {/* <ReactSelect options={ this.state.opcMutables } searchable={true} disabled={this.state.opcMutables.length === 0?true:false} value={this.state.opcMutables_sel} func_onChange={(value)=>{this.setState({opcMutables_sel: value})}}/> */}
                        </ContainerCol>                        
                    </Row>
                    <Row>
                        <ContainerCol className='col-md-4'>
                            <LabelForm>Concepto:</LabelForm>
                            <InputText maxLength='80' mayusculas='true' name='concepto' disabled={this.state.cajaOpe_sel === 'INI'?true:false} value={this.state.concepto} type="text" className='form-control input-sm' placeholder='' onChange={this.changeValueGeneral}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-4'>
                            <LabelForm>Beneficiario:</LabelForm>
                            <InputText  maxLength='40' mayusculas='true' name='beneficiario' disabled={this.state.cajaOpe_sel === 'INI'?true:false} value={this.state.beneficiario} type="text" className='form-control input-sm' placeholder='' onChange={this.changeValueGeneral}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Valor:</LabelForm>
                            <InputText maxLength='7' name='valor' value={this.state.valor} className='form-control input-sm'  onChange={this.ingresoValores}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Forma de pago:</LabelForm>
                            <ReactSelect options={ this.state.tipoIngreso } value={this.state.tipoIngreso_sel} func_onChange={(value)=>{this.setState({tipoIngreso_sel: value})}} />
                        </ContainerCol>                
                    </Row>
                    <Row>                  
                        <div className='col-md-12'>
                            <br/>
                            <div className="btn-group pull-right">
                            <button type="submit" className='btn btn-primary btn-sm' /*disabled={this.state.guardar}*/ onClick={this.guardarMovimiento}>
                                <i className="fa fa-floppy-o fa-lg"></i> Guardar
                            </button>
                            <button type="button" className='btn btn-sm' /*disabled={this.state.limpiar}*/ onClick={this.limpiar}>
                                <i className="fa fa-trash-o fa-lg"></i> Limpiar
                            </button>
                            </div>
                        </div>                  
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return { fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
            permiso: state.sesion.valoresSesionForm.Permiso }
  });
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormCaja02);